// Products that aren't live on prod yet (Packages) show only when this build
// talks to the dev API, or when it runs locally. Prod's REACT_APP_BASEURL is
// the prod API, so prod hides them without needing an extra env var.
export const isDevEnv =
  /\.dev\.tramango\.com/.test(process.env.REACT_APP_BASEURL || "") ||
  window.location.hostname === "localhost";
